import { Popup } from 'antd-mobile';
import CloseIcon from '@/images/h5-self-service/close_icon.webp';
import { useState } from 'react';

interface IProps {
  visible: boolean;
  onClose: () => void;
  onPhotoClick?: () => void;
  onPdfClick?: () => void;
  onBaiduPanClick?: () => void;
  onMaskClick?: () => void;
  showBaiduPan?: boolean;
}

interface IMethod {
  text: string;
  id: string;
}

const PHOTO = 'photo';
const PDF = 'pdf';
const BAIDU_PAN = 'baiduPan';

function AddResourceMethodList({
  visible,
  onClose,
  onPhotoClick,
  onPdfClick,
  onBaiduPanClick,
  onMaskClick,
  showBaiduPan = true,
}: IProps) {
  const _ListData = [
    { text: '百度网盘上传', id: BAIDU_PAN, isShow: showBaiduPan },
    { text: '拍照录入', id: PHOTO, isShow: true },
    { text: '本地PDF文件', id: PDF, isShow: true },
  ];
  const [curItem, setCurItem] = useState<IMethod>();

  function handleSelect(item: IMethod) {
    setCurItem(item);
    if (item.id === PHOTO) {
      onPhotoClick?.();
    }
    if (item.id === PDF) {
      onPdfClick?.();
    }
    if (item.id === BAIDU_PAN) {
      onBaiduPanClick?.();
    }
    onClose();
  }

  return (
    <Popup
      visible={visible}
      onMaskClick={() => {
        onMaskClick?.();
        onClose();
      }}
      onClose={() => {
        onClose();
      }}
      position='bottom'
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        minHeight: '265px',
        background: 'linear-gradient(180deg, #FFFEE4 0%, #FFFFFF 37.58%)',
      }}
    >
      {/* 标题 */}
      <div className='flex items-center justify-between px-[16px] mt-[24px]'>
        <div className='w-[16px]'></div>
        <div className='text-[16px] text-[#000000] font-bold'>选择添加方式</div>
        <img
          onClick={onClose}
          src={CloseIcon}
          className='w-[16px] h-[16px]'
          alt=''
        />
      </div>
      <div className='px-[24px] mt-[32px]'>
        {_ListData
          .filter((cur) => cur.isShow)
          .map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => handleSelect(item)}
                className={`h-[64px] rounded-[20px] bg-[#F7F7F7] text-[#333333] flex items-center text-[14px] font-bold pl-[16px] mb-[14px] ${
                  item.id === curItem?.id
                    ? 'bg-[#FFFCE8] border-[3px] border-[#FFDDA3]'
                    : ''
                }`}
              >
                {item.text}
              </div>
            );
          })}
      </div>
    </Popup>
  );
}

export default AddResourceMethodList; 